import { omit } from "lodash";
import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@/components/ThemeProvider";

import routeWithUserSession from "@/components/application-area/routeWithUserSession";
import Layout from "@/components/admin/Layout";
import * as StatusBlock from "@/components/admin/StatusBlock";

import { axios } from "@/services/axios";
import recordEvent from "@/services/recordEvent";
import routes from "@/services/routes";

import "./system-status.less";

function SystemStatus({ onError }) {
  const [state, setState] = useState({
    queues: [],
    manager: null,
    databaseMetrics: {},
    status: {},
  });

  const { isDarkMode } = useTheme();

  const refresh = useCallback(() => {
    axios
      .get("/status.json")
      .then(data => {
        setState({
          queues: data.manager.queues,
          manager: {
            startedAt: data.manager.started_at * 1000,
            lastRefreshAt: data.manager.last_refresh_at * 1000,
            outdatedQueriesCount: data.manager.outdated_queries_count,
          },
          databaseMetrics: data.database_metrics.metrics || [],
          status: omit(data, ["workers", "manager", "database_metrics"]),
        });
      })
      .catch(error => onError(error));
  }, [onError]);

  useEffect(() => {
    recordEvent("view", "page", "admin/status");
    refresh();

    const refreshTimer = setInterval(refresh, 60 * 1000);

    return () => {
      clearInterval(refreshTimer);
    };
  }, [refresh]);

  return (
    <Layout activeTab="system_status">
      <div className={`system-status-page ${isDarkMode ? "dark-mode" : ""}`}>
        <div className="system-status-page-blocks">
          <div className="system-status-page-block">
            <StatusBlock.General info={state.status} />
          </div>
          <div className="system-status-page-block">
            <StatusBlock.Manager info={state.manager} />
          </div>
          <div className="system-status-page-block">
            <StatusBlock.Queues info={state.queues} />
          </div>
          <div className="system-status-page-block">
            <StatusBlock.DatabaseMetrics info={state.databaseMetrics} />
          </div>
        </div>
      </div>
    </Layout>
  );
}

SystemStatus.propTypes = {
  onError: PropTypes.func,
};

SystemStatus.defaultProps = {
  onError: () => {},
};

routes.register(
  "Admin.SystemStatus",
  routeWithUserSession({
    path: "/admin/status",
    title: "System Status",
    render: pageProps => <SystemStatus {...pageProps} />,
  })
);

export default SystemStatus;
